import React, { useCallback, useEffect } from "react";
import Select from "react-select";
import MangerSelect from "../MangerSelect/MangerSelect";
import ContractSelect from "../ContractSelect/ContractSelect";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers } from "../../../redux/userSlice/userSlice";

export default function MaintenanceScheduleInputs({ maintenanceSchedules, setMaintenanceSchedules, contracts, users }) {
  const priorityOptions = [
    { value: "low", label: "منخفض" },
    { value: "medium", label: "متوسط" },
    { value: "high", label: "عالي" },
    { value: "urgent", label: "عاجل" },
  ];
  const handlePriorityChange = (e) => {
    setMaintenanceSchedules({ ...maintenanceSchedules, priority: e.value });
  };
  const handleMangerSelectChange = (selectedOption) => {
    setMaintenanceSchedules({
      ...maintenanceSchedules,
      maintenance_manager_id: selectedOption ? selectedOption.value : null,
    });
  };
  const handleChangeManger = useCallback((selected) => {}, []);
  return (
    <>
      <section className="row mb-5">
        <h4>
          <span>بيانات الجدول</span>
        </h4>
        <div className="col-lg-6 mt-3 mb-2">
          <MangerSelect
            value={maintenanceSchedules?.maintenance_manager_id}
            onChange={(selectedValue) =>
              setMaintenanceSchedules({
                ...maintenanceSchedules,
                maintenance_manager_id: selectedValue,
              })
            }
            users={users}
          />
        </div>

        <div className="col-lg-6 mt-3 mb-2">
          <label htmlFor="title">اسم الجدول</label>
          <input
            type="text"
            placeholder="اسم الجدول"
            id="title"
            value={maintenanceSchedules?.title || ""}
            className="form-control"
            onChange={(e) =>
              setMaintenanceSchedules({
                ...maintenanceSchedules,
                [e.target.id]: e.target.value,
              })
            }
          />
        </div>
        <div className="col-lg-6 mt-3 mb-2">
          <label htmlFor="schedule_date">تاريخ الجدول</label>
          <input
            type="date"
            placeholder="تاريخ الجدول"
            id="schedule_date"
            value={maintenanceSchedules?.schedule_date || ""}
            className="form-control text-start"
            onChange={(e) =>
              setMaintenanceSchedules({
                ...maintenanceSchedules,
                [e.target.id]: e.target.value,
              })
            }
          />
        </div>
        <div className="col-lg-6 mt-3 mb-2">
          <label htmlFor="start_time">بداية الوقت</label>
          <input
            type="time"
            placeholder="بداية الوقت"
            id="start_time"
            value={maintenanceSchedules?.start_time || ""}
            className="form-control text-start"
            onChange={(e) =>
              setMaintenanceSchedules({
                ...maintenanceSchedules,
                [e.target.id]: e.target.value,
              })
            }
          />
        </div>
        <div className="col-lg-6 mt-3 mb-2">
          <label htmlFor="end_time">نهاية الوقت</label>
          <input
            type="time"
            placeholder="نهاية الوقت"
            id="end_time"
            value={maintenanceSchedules?.end_time || ""}
            className="form-control text-start"
            onChange={(e) =>
              setMaintenanceSchedules({
                ...maintenanceSchedules,
                [e.target.id]: e.target.value,
              })
            }
          />
        </div>
        <div className="col-lg-6 mt-3 mb-2">
          <label htmlFor="priority">الأولوية</label>
          <Select
            classNames={{
              control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
            }}
            options={priorityOptions}
            value={maintenanceSchedules?.priority ? priorityOptions.find((option) => option.value === maintenanceSchedules.priority) : null}
            onChange={handlePriorityChange}
            placeholder="اختر الأولوية"
            isSearchable
          />
        </div>
        <div className="col-lg-6 mt-3 mb-2">
          <label htmlFor="notes">ملاحظات</label>
          <input
            type="text"
            placeholder="ملاحظات"
            id="notes"
            value={maintenanceSchedules?.notes || ""}
            className="form-control"
            onChange={(e) =>
              setMaintenanceSchedules({
                ...maintenanceSchedules,
                [e.target.id]: e.target.value,
              })
            }
          />
        </div>
        <div className="col-lg-6 mt-3 mb-2">
          <label htmlFor="has_fire_extinguishers">هل هو جدول حرايق؟</label>
          <div class="checkbox-wrapper-19">
            <input
              checked={maintenanceSchedules?.has_fire_extinguishers || false}
              onChange={(e) =>
                setMaintenanceSchedules({
                  ...maintenanceSchedules,
                  [e.target.id]: e.target.checked,
                })
              }
              type="checkbox"
              id={`has_fire_extinguishers`}
            />
            <label htmlFor={`has_fire_extinguishers`} class="check-box" />
          </div>
        </div>
        <div className="col-12 mt-3 mb-2">
          <ContractSelect contracts={contracts} maintenanceSchedules={maintenanceSchedules} setMaintenanceSchedules={setMaintenanceSchedules} />
        </div>
      </section>
    </>
  );
}
